import { Badge } from "./kit/badge";

interface MetadataBadgeProps {
  label: string;
  value: string;
  variant?: "default" | "compact";
}

export const MetadataBadge = ({
  label,
  value,
  variant = "default",
}: MetadataBadgeProps) => {
  if (variant === "compact") {
    return (
      <div className="inline-flex items-center gap-1 rounded-md bg-secondary/80 px-2 py-0.5">
        <span className="text-[11px] font-semibold text-muted-foreground">
          {label}:
        </span>
        <span className="text-[12px]">{value}</span>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-1.5 rounded-md bg-secondary/80 px-3 py-1.5 text-sm">
      <Badge
        variant="secondary"
        className="px-0 py-0 text-[13px] font-semibold bg-transparent border-0 text-muted-foreground"
      >
        {label}:
      </Badge>
      <span className="text-[14px]">{value}</span>
    </div>
  );
};
